import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { ProductExclusionReason } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const HideProductsMutation = graphql(`
  mutation HideProducts($input: HideProductsInput!) {
    hideProducts(input: $input) {
      id
      __typename
      clientId
      productId
      productName {
        locale
        value
      }
      reason
      reasonText
      validTo
    }
  }
`);

export interface HideProductsInput {
  clientId: string;
  products: string[];
  reason: ProductExclusionReason;
  reasonText: string;
  validTo: string | null;
}

export function useHideProducts() {
  const [result, hideProductsMutation] = useMutation(HideProductsMutation);
  const [error, setError] = useState<Error | null>(null);

  const hideProducts = useCallback(
    async (input: HideProductsInput) => {
      try {
        const response = await hideProductsMutation({ input });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.hideProducts;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [hideProductsMutation],
  );

  return { hideProducts, result, error };
}
